import { bindable, inject, IEventAggregator, resolve } from 'aurelia';
import { TripApi } from '../../services/trip-api'

@inject(TripApi)
export class DestinationGroupDetails {

    @bindable packageGroup;

    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    aurelia_options = aurelia_options;
    eventAggregator = resolve(IEventAggregator);
    subscriptions = [];
    openedHotel = null;

    constructor(tripApi) {
        this.tripApi = tripApi;
        this.hotels = null;
    }

    attached() {
        // subscribe to detail load events - sent from trip-list when detailview is opened
        this.subscriptions.push(this.eventAggregator.subscribe(`load-packagegroup-details-${this.packageGroup.packagegroup_id}`, params => this.loadPackagegroupDetails(params)));

        // Hotel was loaded with packagegroup query - expand all packagegroups
        if (this.packageGroup.hotel !== undefined) {
            this.hotels = [this.packageGroup.hotel];
            document.querySelector(`#packagegroup-${this.packageGroup.packagegroup_id}`).style.removeProperty('display');
        }
    }

    detached() {
        this.subscriptions.forEach(subscription => {
            subscription.dispose();
        });
    }

    loadPackagegroupDetails(params) {
        if (this.hotels !== null) return; // already loaded
        // call backend and load packagegroup items
        // request the dataset size (packagegroup), usually ca 3k items
        this.tripApi.getTripPackagegroupItems(this.packageGroup.packagegroup_id, params.searchParameters).then(data => {
            for (let hotel of data.result) {
                hotel.selected_room_id = hotel.rooms[0].id;
                hotel.selected_mealplan_id = hotel.rooms[0].mealplans[0].id;
            };
            this.hotels = data.result;
        });
    }

    closePackageDetailView(packagegroup_id) {
        $('#packagegroup-' + packagegroup_id).slideUp();
    }

    showInquiryModal(hotel) {
        this.openedHotel = hotel;
    }
    closeInquiryModal() {
        this.openedHotel = null;
    }

    getDestination(packageGroup) {
        let destination = "";

        if (packageGroup.country_info[this.aurelia_options.language] !== undefined) {
            destination = packageGroup.country_info[this.aurelia_options.language];
        } else {
            destination = packageGroup.country;
        }

        if (packageGroup.resort_info[this.aurelia_options.language] != undefined) {
            destination = destination + ', ' + packageGroup.resort_info[this.aurelia_options.language];
        } else {
            destination = destination + ', ' + packageGroup.resort;
        }

        return destination;
    }
}
